import { EOverdueType } from 'shared/stores/use-overdue-filters';

export const overdueTabs = [
  { key: EOverdueType.unloading, label: 'Unloading' },
  { key: EOverdueType.loading, label: 'Loading' },
];
